export function getNumberLength(objTipoJogo, isBicho = false) {
    return isBicho ? 2 : ((objTipoJogo && objTipoJogo.tnyTamanhoMax) || 4);
}


// WEBPACK FOOTER //
// ./src/rifa/utils/getNumberLength.js